// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__271jB","main":"Footer_main__1stRs","names":"Footer_names__2F_6J","commentMessage":"Footer_commentMessage__2LJDf","email":"Footer_email__1yedv"};